import React from 'react';

import { Icon } from '../icons';

export const ArrowBottomLeftIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5271 12.2851L13.5271 13.4063C13.5271 13.881 13.1433 14.2648 12.6711 14.2623L2.85602 14.2648C2.3813 14.2648 1.99749 13.881 2.00001 13.4088V3.5912C2.00001 3.11648 2.38383 2.73267 2.85602 2.73519L3.97716 2.73519C4.45693 2.73519 4.84327 3.13163 4.83317 3.6114L4.68924 9.55296L11.9464 2.29582C12.2822 1.95999 12.8226 1.95999 13.1584 2.29582L13.9665 3.10386C14.3023 3.43969 14.3023 3.98006 13.9665 4.3159L6.70932 11.573L12.6509 11.4291C13.1332 11.4165 13.5296 11.8028 13.5271 12.2851Z"
      />
    </svg>
  );
};
